import { Badge, Tooltip } from '@acceso/design-system';

type TLimitDisplayProps<T> = {
  items: T[];
  limit?: number;
  renderItem: (item: T) => React.ReactNode;
  renderTooltip?: (items: T[]) => React.ReactNode;
};

export function LimitDisplay<T>({
  items,
  limit = 1,
  renderItem,
  renderTooltip,
}: TLimitDisplayProps<T>) {
  if (!items.length) return null;

  const visible = items.slice(0, limit);
  const remaining = items.slice(limit);

  return (
    <div className="flex flex-wrap gap-1">
      {visible.map(renderItem)}
      {remaining.length > 0 && (
        <Tooltip
          help={
            renderTooltip ? (
              renderTooltip(remaining)
            ) : (
              <div>
                {remaining.map((item, idx) => (
                  <span key={idx}>{JSON.stringify(item)}</span>
                ))}
              </div>
            )
          }
        >
          <Badge>+ {remaining.length}</Badge>
        </Tooltip>
      )}
    </div>
  );
}
